import React from 'react'
import DemandComponent from '../../components/DemandComponent'

function Demand() {
  return <DemandComponent />
}

export default Demand
